<template>
    <tr
        v-if="isEditable"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ classification.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            <div
                class="form-widget without-label date-picker"
                :class="{ invalid: !editClassification.start || !editClassification.isValidDateRange() }"
            >
                <kgr-date-picker
                    v-model="editClassification.start"
                />
            </div>
        </td>
        <td class="kgr-table__cell">
            <div
                class="form-widget without-label date-picker"
                :class="{ invalid: !editClassification.isValidDateRange() }"
            >
                <kgr-date-picker
                    v-model="editClassification.end"
                />
            </div>
        </td>
        <td class="kgr-table__cell">
            <div class="form-widget without-label date-picker">
                <textarea
                    v-model.trim="editClassification.notice"
                    class="kgr-input"
                    rows="3"
                ></textarea>
            </div>
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <button
                type="button"
                class="kgr-table__action"
                disabled
            >
                <kgr-icon-edit
                    :size="15"
                    disabled
                />
            </button>
            <button
                type="button"
                class="kgr-table__action"
                @click="$emit('remove')"
            >
                <kgr-icon-delete />
            </button>
        </td>
    </tr>
</template>

<script>
import DatePicker from '../../common/form/picker/DatePicker';
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import MemberClassification from '../../../js/dto/MemberClassification';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
    },
    props: {
        classification: {
            type: MemberClassification,
            required: true,
        },
        editClassifications: {
            type: Array,
            required: true,
        },
    },
    computed: {
        isEditable() {
            return this.editIndex !== -1;
        },
        editIndex() {
            return this.editClassifications.map((editClassification) => editClassification.id).indexOf(this.classification.id);
        },
        editClassification() {
            return this.editClassifications[this.editIndex];
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .kgr-table__cell {
    vertical-align: top;
}

div .date-picker {
    border: 1px solid transparent;

    &.invalid {
        border: 1px solid #f44336;
    }
}
</style>
